/*
  Caviére cart drawer extras (Feature 1)
  One-tap "Complete the ritual" add-ons inside the Dawn cart drawer.
  Plain JavaScript, no libraries. About 2 KB.
*/
(function () {
  if (window.__caviereCartExtras) return;
  window.__caviereCartExtras = true;

  function addUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  function announce(message) {
    var live = document.getElementById('CartDrawer-LiveRegionText');
    if (!live || !message) return;
    live.textContent = message;
    live.setAttribute('aria-hidden', 'false');
    setTimeout(function () {
      live.setAttribute('aria-hidden', 'true');
    }, 1500);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-caviere-addon]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();

    var drawer = document.querySelector('cart-drawer');
    var label = button.querySelector('.cav-addon__btn-label');
    var originalLabel = label ? label.textContent : '';
    var group = button.closest('.cav-addons');
    var errorBox = group ? group.querySelector('.cav-addons__error') : null;
    var variantId = Number(button.getAttribute('data-variant-id'));

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    if (label) label.textContent = button.getAttribute('data-loading-text') || 'Adding';
    if (errorBox) errorBox.textContent = '';

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          throw new Error(result.data.description || result.data.message || 'This item could not be added.');
        }

        if (drawer && typeof drawer.renderContents === 'function' && result.data.sections) {
          // Re-renders the whole drawer: items, free shipping bar, add-ons and totals.
          drawer.renderContents(result.data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        announce(button.getAttribute('data-added-text'));
        document.dispatchEvent(
          new CustomEvent('caviere:addon-added', { detail: { variantId: variantId, source: 'cart-drawer' } })
        );
      })
      .catch(function (error) {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        if (label) label.textContent = originalLabel;
        if (errorBox) errorBox.textContent = error.message;
      });
  });
})();